import React, { useEffect } from 'react';
import { Play, Check } from 'lucide-react';
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from 'react-router-dom';

const Techarea = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  const foundingYear = 1999; // ⏪ Change this to your company's founding year
  const currentYear = new Date().getFullYear();
  const yearsOfExperience = currentYear - foundingYear;

  return (
    <div className="bg-gray-100 bg_image_Techarea">
      {/* Hero Section */}
      <div className="containers mx-auto px-4 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div className="order-2 lg:order-1 space-y-8" data-aos="fade-right">
            {/* Small Tag */}
            <div className="inline-flex items-center space-x-2" data-aos="fade-up">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span className="text-[#1C74BB] font-medium text-sm">What Else Here</span>
            </div>

            {/* Main Heading */}
            <h1
              className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 leading-tight"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              The Best Tech Solutions
              <br />
              <span className="text-gray-700">for Our Clients</span>
            </h1>

            {/* Description */}
            <p
              className="text-gray-600 text-lg lg:text-xl leading-relaxed max-w-lg"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              We pride ourselves on delivering results-driven digital products that bring real business value
            </p>

            {/* Feature List */}
            <div className="space-y-6">
              {/* Feature 1 */}
              <div className="flex items-center space-x-4" data-aos="fade-up" data-aos-delay="600">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mt-1">
                  <Check className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 ">
                    250+ clients across India
                  </h3>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="flex items-center space-x-4" data-aos="fade-up" data-aos-delay="800">
                <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mt-1">
                  <Check className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 ">
                    25+ industries served, from startups to enterprises
                  </h3>

                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="pt-4" data-aos="zoom-in" data-aos-delay="1000">
              <Link to="/Contact" onClick={() => window.scrollTo(0, 0)} className="button_same  text-white py-[14px] px-[18px] rounded-md font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105">
                Discover More
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="order-1 lg:order-2 relative" data-aos="fade-left">
            <div className="relative">
              {/* Main Image Container */}
              <div className="bg-gradient-to-br from-blue-500 to-blue-700 rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                  alt="Professional team working together"
                  className="w-full h-96 lg:h-[500px] object-cover"
                />

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center" data-aos="zoom-in" data-aos-delay="400">
                  <button className="w-20 h-20 bg-white rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-transform duration-200 group">
                    <Play className="w-8 h-8 text-blue-600 ml-1 group-hover:text-blue-700" fill="currentColor" />
                  </button>
                </div>
              </div>

              {/* Floating Stats Card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 hidden sm:block" data-aos="fade-up" data-aos-delay="600">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                    <div className="w-6 h-6 bg-orange-500 rounded-full"></div>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">70+</p>
                    <p className="text-gray-600 text-sm">Happy Clients</p>
                  </div>
                </div>
              </div>

              {/* Floating Experience Card */}
              <div className="absolute -top-6 -right-6 bg-white rounded-2xl shadow-xl p-6 hidden sm:block" data-aos="fade-down" data-aos-delay="800">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                    <div className="w-6 h-6 bg-green-500 rounded-full"></div>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-gray-900">{yearsOfExperience}+</p>
                    <p className="text-gray-600 text-sm">Years Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Techarea;
